import { useState } from "react";
import { useTheme } from "../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import { Tabs } from "../../../components/common/Tabs";
import { RepairOrderList } from "./RepairOrderList";
import colorConfigs from "../../../configs/colorConfigs";

const tabs = [
  {
    label: "All",
  },
  {
    label: "Due This Week",
  },
]

const filterItems = [
  {
    id: 0,
    label: "Maintenance Type",
  },
  {
    id: 1,
    label: "Vehicle Name",
  },

]

export const RepairOrders = () => {
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>("");
  const [repaiOrderilterValue, setRepaiOrderilterValue] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);

  const hanbleTabChange = (index: number) => {
    setActiveIndex(index);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    })
    setRepaiOrderilterValue(0);
    setSelectedFilter(filterItems[0].label);
  }

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div className="flex items-center justify-end">
          <div className="flex items-center gap-2.5">
            <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
              onClick={() => navigate("/fleet/repairorders/addrepairorder")}
            >
              <span className="material-symbols-outlined text-[25px] font-light">
                add
              </span>
              <span className="text-xs font-medium">Repair Order</span>
            </button>

          </div>
        </div>
        <div className="w-full mt-2">
          <Tabs tabs={tabs} onChange={(index) => hanbleTabChange(index)} activeIndex={activeIndex} />
        </div>

        <div>
          <RepairOrderList
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            activeIndex={activeIndex}
            repaiOrderilterValue={repaiOrderilterValue}
            setRepaiOrderilterValue={setRepaiOrderilterValue}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            filterItems={filterItems}
          />
        </div>
      </div>
    </div>
  )
}